__turbopack_context__.v({
  "root": "NJvwSq_root",
});
